"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutToolbarButtons = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var LayoutContext_1 = require("./LayoutContext");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var dynamic_1 = require("@vanilla-extract/dynamic");
var inversify_react_1 = require("inversify-react");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var EvenlyDistributeColumns_1 = require("./EvenlyDistributeColumns");
var lodash_1 = require("lodash");
var SCALING_FACTOR = 6;
var Slider = function (_a) {
    var label = _a.label, onChange = _a.onChange, initialValue = _a.initialValue;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { paddingBottom: "s" },
        react_1.default.createElement(kaleidoscope_1.SliderInput, { label: label, handleValueChange: function (value) {
                onChange(value * SCALING_FACTOR);
            }, theme: kaleidoscope_1.SliderTheme.Dark, maximum: 240 / SCALING_FACTOR, minimum: 0, initialInputValue: initialValue / SCALING_FACTOR })));
};
var SpacingPopover = function (_a) {
    var element = _a.element, gap = _a.gap, padding = _a.padding;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var updatePadding = function (padding) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
            action: "updatePadding",
            path: widgetManager.getPath(element),
            padding: padding,
        }));
    };
    var updateGap = function (gap) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
            action: "updateGap",
            path: widgetManager.getPath(element),
            gap: gap,
        }));
    };
    return (react_1.default.createElement(kaleidoscope_1.Popover, { className: tokens_1.darkTheme, size: kaleidoscope_1.PopoverSize.Medium, theme: kaleidoscope_1.PopoverTheme.Dark, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ key: "spacing", className: tokens_1.darkTheme, type: kaleidoscope_1.ButtonType.Tertiary }, buttonProps),
            react_1.default.createElement(icons_1.Sliders, null),
            " Spacing")); }, offset: 12 },
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
            react_1.default.createElement(Slider, { label: "Outer padding", initialValue: padding, onChange: updatePadding }),
            react_1.default.createElement(Slider, { label: "Column gaps", initialValue: gap, onChange: updateGap }))));
};
var TidyButton = function (_a) {
    var _b;
    var element = _a.element, tidyColumns = _a.tidyColumns;
    var isEvenlyDistributedColumns = react_1.default.useMemo(function () {
        var currentWidths = element.data.columns.map(function (_a) {
            var width = _a.width;
            return width;
        });
        var evenWidths = (0, EvenlyDistributeColumns_1.getEvenWidths)(element.data.columns.length);
        return (0, lodash_1.isEqual)(evenWidths, currentWidths);
    }, [element.data.columns]);
    if (isEvenlyDistributedColumns)
        return null;
    var numberOfColumns = (_b = element.data.columns) === null || _b === void 0 ? void 0 : _b.length;
    var tidyResultsInUnevenColumns = (0, EvenlyDistributeColumns_1.isNonEvenColumnWidths)(numberOfColumns);
    if (tidyResultsInUnevenColumns) {
        return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "".concat(numberOfColumns, " columns can't be divided equally") },
            react_1.default.createElement(kaleidoscope_1.Button, { key: "tidy", className: tokens_1.darkTheme, type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () { return tidyColumns(); } },
                react_1.default.createElement(icons_1.Spark, null),
                " Tidy")));
    }
    return (react_1.default.createElement(kaleidoscope_1.Button, { key: "tidy", className: tokens_1.darkTheme, type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () { return tidyColumns(); } },
        react_1.default.createElement(icons_1.Spark, null),
        " Tidy"));
};
var AlignmentPopover = function (_a) {
    var element = _a.element, alignment = _a.alignment;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var updateAlignment = function (alignment) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
            action: "updateAlignment",
            path: widgetManager.getPath(element),
            alignment: alignment,
        }));
    };
    return (react_1.default.createElement(kaleidoscope_1.Popover, { padding: "none", className: tokens_1.darkTheme, size: kaleidoscope_1.PopoverSize.Medium, theme: kaleidoscope_1.PopoverTheme.Dark, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ key: "spacing", className: tokens_1.darkTheme, type: kaleidoscope_1.ButtonType.Tertiary }, buttonProps),
            react_1.default.createElement(icons_1.AlignVerticalCenter, null),
            " Align")); }, offset: 12 },
        react_1.default.createElement(kaleidoscope_1.Stack, { padding: "s" },
            react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Align", labelHidden: true, theme: kaleidoscope_1.SegmentedControlTheme.Dark, onClickHandler: updateAlignment, options: [
                    {
                        label: "Align top",
                        icon: react_1.default.createElement(icons_1.AlignVerticalTop, null),
                        value: "start",
                    },
                    {
                        label: "Align center",
                        icon: react_1.default.createElement(icons_1.AlignVerticalCenter, null),
                        value: "center",
                    },
                    {
                        label: "Align bottom",
                        icon: react_1.default.createElement(icons_1.AlignVerticalBottom, null),
                        value: "end",
                    },
                ], selectedValue: alignment }))));
};
var LayoutToolbarButtons = function (_a) {
    var _b;
    var element = _a.element;
    var _c = (0, LayoutContext_1.useLayoutContext)(), editMode = _c.editMode, setEditMode = _c.setEditMode;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var tidyColumns = function () {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("layout", {
            action: "tidyColumns",
            path: widgetManager.getPath(element),
        }));
    };
    if (element.isVoid)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null, editMode ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(kaleidoscope_1.Button, { key: "done", className: tokens_1.darkTheme, style: (0, dynamic_1.assignInlineVars)((_b = {},
                _b[tokens_1.tokens.color.surfaceHover] = tokens_1.palette.green700,
                _b[tokens_1.tokens.color.text] = tokens_1.palette.green400,
                _b[tokens_1.tokens.color.icon] = tokens_1.palette.green500,
                _b)), type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () {
                setEditMode(false);
            } },
            react_1.default.createElement(icons_1.Tick, null),
            " Done"),
        react_1.default.createElement(SpacingPopover, { element: element, gap: element.data.gap, padding: element.data.padding }),
        react_1.default.createElement(AlignmentPopover, { element: element, alignment: element.data.alignment }),
        react_1.default.createElement(TidyButton, { element: element, tidyColumns: function () { return tidyColumns(); } }))) : (react_1.default.createElement(kaleidoscope_1.Button, { key: "edit", className: tokens_1.darkTheme, type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () {
            setEditMode(true);
        } },
        react_1.default.createElement(icons_1.Edit, null),
        " Edit layout"))));
};
exports.LayoutToolbarButtons = LayoutToolbarButtons;
